import { render, staticRenderFns } from "./newDealCompany.vue?vue&type=template&id=7bbfb58e&scoped=true"
import script from "./newDealCompany.vue?vue&type=script&lang=js"
export * from "./newDealCompany.vue?vue&type=script&lang=js"
import style0 from "./newDealCompany.vue?vue&type=style&index=0&id=7bbfb58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbfb58e",
  null
  
)

export default component.exports